const StyledText = ({value: {value, color}}) => {
  const style = { color };
  return <span style={style}>{value}</span>
};

export default StyledText;
